import { identifyUser, trackEvent, trackPageView } from "@redux-beacon/segment";

import {
  LOGIN_USER_SUCCESS,
  TRACK_SEGMENT_EVENT,
  CHANGE_TAB,
  ADD_DEAL_SUCCESS,
  SET_TRACKING_EVENT,
  UPLOAD_LIST_SUCCESS,
  SELECT_ACTIVE_PROPERTY,
  UPLOAD_EDIT_PHOTO_SUCCESS,
  POST_NOTE_SUCCESS,
  UPDATE_NOTE_SUCCESS,
  SEARCH_CHANGED,
  GET_TEMPLATES_SUCCESS
} from "app/DealMachineCore/types";

const insiviaMap = new Map([
  ["updateUserSuccess_verify_phone", "signup_validate_phone"],
  ["updateUserSuccess_verify_email", "signup_validate_email"],
  ["registerSuccess", "signup_create_account"],
  ["dashboard_goals_confirm", "dashboard_onboard_goals"],
  ["text_link", "dashboard_onboard_getapp"],
  ["updateOwnerInfoSuccess_skip_trace", "deal_trace_data"],
  ["updateOwnerInfoSuccess_edit_property_address", "deal_add_address"],
  ["updateOwnerInfoSuccess_create_phone_number", "deal_add_phone"],
  ["updateOwnerInfoSuccess_create_email_address", "deal_add_email"],
  ["updateLeadSuccess_start_mailers", "deal_start_mailers"],
  ["updateLeadSuccess_edit_status_for_lead", "deal_edit_status"],
  ["updateLeadSuccess_edit_lists_for_lead", "deal_edit_list"],
  ["updateLeadSuccess_edit_tags_for_lead", "deal_edit_tag"],
  ["updateLeadSuccess_permanently_delete", "deal_trash"],
  ["getSignaturesSuccess", "deal_view_signature"],
  ["createSignatureSuccess", "deal_create_signature"],
  ["saveSignatureSuccess", "deal_edit_signature"],
  ["deleteSignatureSuccess", "deal_delete_signature"],
  ["getTemplatesSuccess", "deal_view_templates"],
  ["deleteTemplateSuccess", "deal_delete_template"],
  ["saveTemplateSuccess", "deal_edit_template"],
  ["createTemplateSuccess", "deal_create_template"],
  ["createCampaignSuccess", "deal_create_campaign"],
  ["editCreditsSuccess", "deal_increase_credits"],
  ["updateBillingAddonSuccess_purchase", "deal_upgrade_campaigns"],
  ["updateBillingAddonSuccess_cancel", "deal_downgrade_campaigns"]
]);

export const eventsMap = {
  [LOGIN_USER_SUCCESS]: identifyUser(action => ({
    userId: action.payload.user.id,
    traits: {
      username: action.payload.user.username,
      email: action.payload.user.email
    }
  })),
  [TRACK_SEGMENT_EVENT]: trackEvent(action => {
    return {
      name: action.payload.event,
      properties: action.payload
    };
  }),
  [CHANGE_TAB]: trackPageView(action => {
    return {
      name: action.payload + "_view",
      properties: {
        path: window.location.pathname,
        url: window.location.href
      }
    };
  }),
  [SET_TRACKING_EVENT]: trackEvent(action => {
    const name = insiviaMap.has(action.payload)
      ? insiviaMap.get(action.payload)
      : action.payload;
    return {
      name
    };
  }),
  [UPLOAD_LIST_SUCCESS]: trackEvent(() => {
    return {
      name: "deal_import_list"
    };
  }),
  [ADD_DEAL_SUCCESS]: trackEvent(() => {
    return {
      name: "deal_add_lead"
    };
  }),
  [SELECT_ACTIVE_PROPERTY]: trackEvent(() => {
    return {
      name: "deal_view_single"
    };
  }),
  [UPLOAD_EDIT_PHOTO_SUCCESS]: trackEvent(() => {
    return {
      name: "deal_edit_photo"
    };
  }),
  [POST_NOTE_SUCCESS]: trackEvent(() => {
    return {
      name: "deal_add_note"
    };
  }),
  [UPDATE_NOTE_SUCCESS]: trackEvent(() => {
    return {
      name: "deal_edit_note"
    };
  }),
  [SEARCH_CHANGED]: trackEvent(() => {
    return {
      name: "deal_search"
    };
  }),
  [GET_TEMPLATES_SUCCESS]: trackEvent(() => {
    return {
      name: "deal_view_templates"
    };
  })
};
